import { styled } from '@mui/material';
import { QCard } from '@kw/quokka-ui';

export const StyledIntegrationCard = styled(QCard)`
  width: 40%;
  min-width: 420px;
  margin: 20px;
  height: fit-content;
`;
